import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllAirportLocation = createAsyncThunk(
  'airportLocation/getAllAirportLocation',
  async ({ limit = 10, page = 1, search, sortBy, sortOrder, filters }, thunkAPI) => {
    let newUrl = `/admin/airport-location?limit=${limit}&page=${page}`;

    if (search) {
      newUrl += `&search=${search}`;
    }

    if (sortBy) {
      newUrl += `&sort_by=${sortBy}`;
    }

    if (sortOrder) {
      newUrl += `&sort_order=${sortOrder}`;
    }

    if (filters && filters.length !== 0) {
      filters.forEach((item) => (newUrl += `&filter_key=${item.filter_key}&filter_value=${item.filter_value}`));
    }

    try {
      const response = await axiosInstance.get(newUrl);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getDetailAirportLocation = createAsyncThunk(
  'airportLocation/getDetailAirportLocation',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/admin/airport-location/${id}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const createAirportLocation = createAsyncThunk(
  'airportLocation/createAirportLocation',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `/admin/airport-location`,
        { ...payload },
        {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        },
      );

      const data = await response.data;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const updateAirportLocation = createAsyncThunk(
  'airportLocation/updateAirportLocation',
  async (payload, thunkAPI) => {
    const { payloadData, airportLocationId } = payload;

    try {
      const response = await axiosInstance.put(
        `/admin/airport-location/${airportLocationId}`,
        { ...payloadData },
        {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        },
      );

      const data = await response.data;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteAirportLocation = createAsyncThunk('airportLocation/deleteAirportLocation', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/admin/airport-location/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
